import Vue from 'vue';
import ElementUI, { Loading } from 'element-ui';
import App from './App.vue';
import router from './router';
import store from './store';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';
import { queryUrl } from '@/utils/util';

Vue.use(ElementUI, {locale});
Vue.config.productionTip = false;

async function getUserInfo() {
  const loading = Loading.service({
    fullscreen: true,
    customClass: 'app-loading',
    background: '#1c1d21'
  });
  const { appid, redirect_url } = queryUrl(window.location.href);

  await store.dispatch('updateAppInfo', {
    appid: appid || '01e5928099b54933bcf1ebad2bf81c32',
    redirect_url: redirect_url || encodeURIComponent('https://cozytaps.com/desktop'),
  });
  // await store.dispatch('updateUserInfo');
  loading.close();
}

Promise.all([
  getUserInfo()
]).then(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
});
